import { HttpClient } from "../../../core/request";

export const fetchContent = () => HttpClient().get("/contents/dd_help_page");



// WEBPACK FOOTER //
// ./src/routes/Help/modules/help.js